import React from 'react';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center max-w-4xl mx-auto" data-id="element-116">
      {/* Background subtle glow */}
      <div className="absolute top-20 left-1/2 -translate-x-1/2 w-[80%] h-[300px] bg-[#d4af37] opacity-[0.03] blur-[100px] rounded-full pointer-events-none" data-id="element-117" />

      <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-10 font-heading animate-fade-in-up" data-id="element-118">
        ¿Cuántas veces más vas a entregar un informe y rezar para que la Obra
        Social no lo rechace?
      </h1>

      {/* Hero image — NO animation, renders immediately for fast LCP */}
      <div className="relative w-full max-w-[600px] mx-auto mb-12 rounded-2xl p-1 bg-gradient-to-b from-[#d4af37]/40 to-transparent gold-glow" data-id="element-119">
        <div className="rounded-xl overflow-hidden bg-[#0a1628]" data-id="element-120">
          <img src="https://cdn.magicpatterns.com/uploads/aCfGkCexWC1BaDE3nrpJV5/formato_1_a_1.jpg" alt="Método Elite AT - El Sistema 360 de Gestión Clínica para Acompañantes Terapéuticos" width={600} height={600} loading="eager" fetchPriority="high" decoding="async" className="w-full h-auto object-cover" data-id="element-121" />
        </div>
      </div>

      <div className="space-y-6 max-w-3xl mx-auto animate-fade-in-up-delay" data-id="element-122">
        <h2 className="text-2xl md:text-3xl font-bold text-gold-gradient font-heading tracking-wide" data-id="element-123">
          MÉTODO ELITE AT
        </h2>
        <h3 className="text-xl md:text-2xl text-white font-medium" data-id="element-124">
          Sistema 360 de Gestión Clínica
        </h3>

        <div className="pt-6 border-t border-[#d4af37]/20 space-y-2" data-id="element-125">
          <p className="text-lg md:text-xl text-[#e2e8f0] font-light" data-id="element-126">
            Hay AT que cobran a término todos los meses.
          </p>
          <p className="text-lg md:text-xl text-[#e2e8f0] font-light" data-id="element-127">
            Y hay AT que esperan con angustia.
          </p>
          <p className="text-xl md:text-2xl text-white font-bold mt-4" data-id="element-128">
            La diferencia es un sistema.
          </p>
        </div>
      </div>
    </section>;
}